import React, { Component } from "react";

import "./Header.scss"

class Header extends Component {
  constructor() {
    super()
    this.state = {
      isSlided: false,
    }
    this.shareBTN = this.shareBTN.bind(this);
  }
  componentWillMount() {
    window.addEventListener("scroll", () => {
      this.setState({
        isSlided: (window.scrollY > 0.10 * window.screen.width ? true : false)
      })
    });
  }
  shareBTN(action) {
    var shareText = "מסע הקפה - מרועה העיזים האתיופי ועד הספל שאתם מחזיקים כל בוקר";
    var url = "https://z.ynet.co.il/short/commerce/2018/nespresso/";
    switch (action) {
      default:
      case "facebook":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'nespresso',
          'Action': 'Share_Facebook',
          'Label': url
        });
        window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(url) + "&redirect_uri=" + encodeURIComponent(url), "_blank");
        break;
      case "twitter":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'nespresso',
          'Action': 'Share_Twitter',
          'Label': url
        });
        window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(url), "_blank");
        break;
      case "whatsapp":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'nespresso',
          'Action': 'Share_WhatsApp',
          'Label': url
        });
        window.open("whatsapp://send?text=" + encodeURIComponent(shareText + " >> " + url), "_parent");
        break;
      case "negishut":
        window.dataLayer.push({
          'event': 'GA_Event',
          'Category': 'nespresso',
          'Action': 'Accessibility',
          'Label': "Open_Accessibility_Clicked"
        });
        var elem = window.document.getElementById('INDmenu-btn');
        var event = new Event('click');
        elem.dispatchEvent(event);
        break;
    }
  }
  render() {
    return (
      <header>
        <div className="flowers">
          <div className="right"></div>
          <div className="left"></div>
        </div>
        <div className={`bg${this.state.isSlided ? " active" : ""}`}></div>
        <div id="header">
          <div className="padding">
            <div className="container">
              <div className={`rightdesc${this.state.isSlided ? " active" : ""}`}>מסע של קפה</div>
              <div className="logos">
                <div className="pblogo"></div>
                <a href="https://www.nespresso.com/il/he/" title="נספרסו" target="_blank"><div className="sponslogo"></div></a>
              </div>
              <div className="share">
                <div onClick={() => { this.shareBTN("negishut") }} className="negishut"></div>
                <div onClick={() => { this.shareBTN("facebook") }} className="facebook"></div>
                <div onClick={() => { this.shareBTN("twitter") }} className="twitter"></div>
                <div onClick={() => { this.shareBTN("whatsapp") }} className="whatsapp"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="virtual-header"></div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header/Header.js